import { render, staticRenderFns } from "./OverviewPageContainer.vue?vue&type=template&id=2c2985ee&"
import script from "./OverviewPageContainer.vue?vue&type=script&lang=js&"
export * from "./OverviewPageContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports